import FormWrapper from '@components/search/forms/FormWrapper'
import TrailerForm from '@components/search/forms/TrailerForm'
import { frontpageLinks } from '@components/search/formLinks'

const TrailerSearchpageForm = ({ query }) => {
    return (
        <FormWrapper
            Form={TrailerForm}
            formLinks={frontpageLinks}
            overrideDefaultValues={query}
            active={2}
            linksOnTop
        />
    )
}

export default TrailerSearchpageForm